import { Row, Col, Card, Collapse, Button } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
import { useState } from "react";

const DetailHeaderCard = ({ title, rightComponent, details }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <Card className="mb-3 shadow-sm">
            <Card.Body>
                <Row className={`flex-nowrap align-items-center`}>
                    <Col className="flex-grow-0 flex-shrink-0 pe-2">
                        <Button
                            variant="link"
                            className="p-0 text-decoration-none"
                            onClick={toggleCollapse}
                            style={{ color: 'inherit' }}
                        >
                            <FaChevronDown
                                style={{
                                    transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            />
                        </Button>
                    </Col>
                    <Col className="flex-grow-1 pe-0" style={{ minWidth: 0 }}>
                        <Card.Title className="text-nowrap text-truncate mb-0" style={{ fontSize: "1.5rem" }}>
                            {title}
                        </Card.Title>
                    </Col>
                    {rightComponent && (
                        <Col className="flex-grow-0 flex-shrink-0">
                            {rightComponent}
                        </Col>
                    )}
                </Row>
                <Collapse in={!isCollapsed} >
                    <div >
                        <Row className="pt-3">
                            {details.map((detail, index) => (
                                <Col key={index} xs={12} sm={6} md={detail.colSize || 4}>
                                    <div className="mb-2">
                                        <strong style={{ fontWeight: "500" }}>{detail.label}:</strong> {detail.value}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Collapse>
            </Card.Body>
        </Card>
    );
};

export default DetailHeaderCard; 